import { itemProgress } from "@/lib/checklist";

/** Assigned photos against the count asked for. Informational: it never says "blocked". */
export function ChecklistItemProgress({
  requiredCount,
  assignedCount,
}: {
  requiredCount: number;
  assignedCount: number;
}) {
  const progress = itemProgress(requiredCount, assignedCount);
  return (
    <div className="flex items-center gap-2" data-testid="item-progress">
      <div className="h-1.5 w-20 overflow-hidden rounded-full bg-muted" aria-hidden>
        <div className="h-full bg-primary" style={{ width: `${progress.percent}%` }} />
      </div>
      <span className="text-sm tabular-nums text-muted-foreground">
        {progress.assigned} of {progress.required}
        {progress.required === 1 ? " photo" : " photos"}
      </span>
    </div>
  );
}
